import Iconography from '@hid-galaxy-ui/galaxy-react/components/Iconography';
import React from 'react';
interface IiconWithLabel {
  label: string;
  isError: boolean;
}
export default function IconWithLabel(props: IiconWithLabel) {
  const { label, isError } = props;
  return (
    <>
      <Iconography
        icon={isError ? 'circleExclamation' : 'circleCheck'}
        className={isError ? 'hid-color--error' : 'hid-color--success'}
      />
      <span className="hid-password-guidelines__list-text">{label}</span>
    </>
  );
}
